import * as $ from "jquery";
import "waypoints/lib/jquery.waypoints.js";

if (
  !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  )
) {
  var sticky = $(".subnav");
  // @ts-ignore
  $("#revealSubNav").waypoint(function (direction: string) {
    if (direction === "down") {
      sticky.addClass("show");
    } else {
      sticky.removeClass("show");
    }
  });
}
